import React from 'react';

const ProductPage: React.FC = () => {
  return (
    <div style={{ padding: '2rem', maxWidth: '1200px', margin: '0 auto' }}>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '3rem' }}>
        {/* Изображение продукта */}
        <div>
          <div style={{
            height: '400px',
            backgroundColor: '#e0e0e0',
            borderRadius: '8px',
            marginBottom: '1rem'
          }}></div>
          <div style={{ display: 'flex', gap: '0.5rem' }}>
            {[1, 2, 3, 4].map(thumb => (
              <div key={thumb} style={{
                width: '80px',
                height: '80px',
                backgroundColor: '#d0d0d0',
                borderRadius: '4px'
              }}></div>
            ))}
          </div>
        </div>
        
        {/* Информация о продукте */}
        <div>
          <h1 style={{ fontSize: '2rem', marginBottom: '1rem', color: '#333' }}>
            Название продукта
          </h1>
          <p style={{ fontSize: '1.5rem', color: '#0066cc', marginBottom: '1.5rem' }}>
            Цена: по запросу
          </p>
          <div style={{ marginBottom: '2rem' }}>
            <h3 style={{ marginBottom: '0.5rem' }}>Описание:</h3>
            <p style={{ color: '#666', lineHeight: '1.6' }}>
              Подробное описание продукта будет здесь. Информация о характеристиках,
              применении и особенностях полимерной продукции.
            </p>
          </div>
          <div style={{ marginBottom: '2rem' }}>
            <h3 style={{ marginBottom: '0.5rem' }}>Технические характеристики:</h3>
            <ul style={{ color: '#666', lineHeight: '1.8' }}>
              <li>Материал: Полимер</li>
              <li>Размеры: по запросу</li>
              <li>Цвет: различные варианты</li>
              <li>Применение: промышленное</li>
            </ul>
          </div>
          <button style={{
            padding: '0.75rem 2rem',
            backgroundColor: '#0066cc',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            fontSize: '1rem',
            cursor: 'pointer'
          }}>
            Добавить в корзину
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProductPage;